import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderMarkdown } from '~/functions/markdown';
import { useUpdateAccountMutation, useGetAccountWithEuTaxonomyDataQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Check',
  setup: function setup(__props) {
    var route = useRoute();
    var ventureId = computed(function () {
      return route.params.venture;
    });
    var _useGetAccountWithEuT = useGetAccountWithEuTaxonomyDataQuery({
        id: ventureId.value || ''
      }),
      accountResult = _useGetAccountWithEuT.result;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var activityIds = computed(function () {
      var _account$value, _account$value$busine, _account$value$busine2;
      return (account === null || account === void 0 ? void 0 : (_account$value = account.value) === null || _account$value === void 0 ? void 0 : (_account$value$busine = _account$value.businessActivities) === null || _account$value$busine === void 0 ? void 0 : (_account$value$busine2 = _account$value$busine.map(function (e) {
        return e.id;
      })) === null || _account$value$busine2 === void 0 ? void 0 : _account$value$busine2.filter(Boolean)) || [];
    } // remove falsy
    );
    var _useUpdateAccountMuta = useUpdateAccountMutation(),
      updateAccount = _useUpdateAccountMuta.mutate,
      onDone = _useUpdateAccountMuta.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var fundImpactConceptIds = computed(function () {
      var _account$value2, _account$value2$fundS;
      return (account === null || account === void 0 ? void 0 : (_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : (_account$value2$fundS = _account$value2.fundSustainableObjectives) === null || _account$value2$fundS === void 0 ? void 0 : _account$value2$fundS.map(function (e) {
        var _e$concept, _e$concept2;
        if (((_e$concept = e.concept) === null || _e$concept === void 0 ? void 0 : _e$concept.createdBy) !== 'admin@impactnexus.io') {
          var _e$euTaxonomyConcept;
          return (_e$euTaxonomyConcept = e.euTaxonomyConcept) === null || _e$euTaxonomyConcept === void 0 ? void 0 : _e$euTaxonomyConcept.id;
        }
        return (_e$concept2 = e.concept) === null || _e$concept2 === void 0 ? void 0 : _e$concept2.id;
      }).filter(Boolean)) || [];
    });
    var updateActivities = function updateActivities(val) {
      var _account$value3;
      var setA = new Set(val);
      var setB = new Set(activityIds.value);
      var noChange = setA.size === setB.size && _toConsumableArray(setA).every(function (item) {
        return setB.has(item);
      });
      if (noChange) return;
      var input = {
        id: (_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.id,
        businessActivities: val
      };
      if ((val === null || val === void 0 ? void 0 : val.length) > 0) input.hasNoEligibleBusinessActivities = false;
      updateAccount({
        input: input
      });
    };
    var updateHasNoActivities = function updateHasNoActivities(val) {
      var _account$value4;
      var input = {
        hasNoEligibleBusinessActivities: val,
        id: (_account$value4 = account.value) === null || _account$value4 === void 0 ? void 0 : _account$value4.id
      };
      if (val === true) input.businessActivities = [];
      updateAccount({
        input: input
      });
    };
    return {
      __sfc: true,
      route: route,
      ventureId: ventureId,
      accountResult: accountResult,
      account: account,
      activityIds: activityIds,
      updateAccount: updateAccount,
      onDone: onDone,
      fundImpactConceptIds: fundImpactConceptIds,
      updateActivities: updateActivities,
      updateHasNoActivities: updateHasNoActivities,
      renderMarkdown: renderMarkdown
    };
  }
});